export class GruppeTierEinstalldatum {
    einstalldatum: Date;
    anzahl: number;
    anzahl_mit_gewicht?: number;
    gesamtgewicht?: number;
}
